import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Vant from 'vant'
import 'vant/lib/index.css'
import Vconsole from 'vconsole'
import { Toast } from 'vant'
import { has } from '@/utils/directive'
Vue.directive('has', has)
Vue.prototype.$toast = Toast
let vConsole = null
if (process.env.VUE_APP_SECRET !== 'master') {
  vConsole = new Vconsole()
}
export default vConsole
Vue.use(Vant)
Vue.use(Toast)
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
